var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReplaceCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.534,
    height: 15.062,
    viewBox: "0 0 18.534 15.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2192_",
    d: "M18.514,17.858A1.7,1.7,0,0,0,17.025,16H1.489A1.7,1.7,0,0,0,0,17.858V29.229a1.691,1.691,0,0,0,1.489,1.832H17.045A1.7,1.7,0,0,0,18.534,29.2V17.858Zm-1.61.151v1.757H1.61V18.008ZM1.61,29.053V22.778H16.9v6.276ZM15.395,25.79a.924.924,0,0,1-.8,1H10.766a1.029,1.029,0,0,1,0-2.008H14.59A.924.924,0,0,1,15.395,25.79Z",
    transform: "translate(0 -16)",
    fill: "#0072bc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplaceCard);
export default __webpack_public_path__ + "static/media/replace-card.f3643f5281f3739c10f15619d069338b.svg";
export { ForwardRef as ReactComponent };